import { IconSvgElement } from "@hugeicons/react";
import { FC, ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { IconSize } from "shared/components/IconBridge";
import { cx } from "shared/utils/classnames";
import { SVGComponentProps } from "untitledui-js-base";
import { NavLinkContent } from "./NavLinkContent";

export const NavLink: FC<{
  to?: string;
  onClick?: () => void | unknown;
  children: ReactNode;
  Icon?: FC<SVGComponentProps>;
  size?: IconSize;
  HugeIcon?: IconSvgElement;
  target?: "_blank" | "_self" | "_parent" | "_top";
  rel?: string;
  className?: string;
  indicator?: string | number;
  strokeWidth?: number;
  isBeta?: boolean;
}> = ({
  to,
  children,
  Icon,
  target,
  onClick,
  rel,
  className: _className,
  size = IconSize.BASE,
  HugeIcon,
  indicator,
  strokeWidth,
  isBeta
}) => {
  const location = useLocation();
  const [toPathname] = (to ?? "").split("?");
  const isActive = location.pathname === toPathname;

  const className = cx(
    "relative text-sm font-medium flex gap-4 w-full whitespace-nowrap text-ellipsis overflow-hidden break-all items-center p-3 rounded-lg transition-all no-underline my-[2px]",
    isActive
      ? "text-primary-600 stroke-primary-500 bg-primary-20"
      : "text-content-500 stroke-content-500 hover:bg-alpha-40",
    _className
  );

  const contentProps = {
    size,
    Icon,
    HugeIcon,
    children,
    indicator,
    strokeWidth,
    isBeta,
    isActive
  };

  if (!to)
    return (
      <button
        type="button"
        onClick={() => onClick && onClick()}
        className={className}
      >
        <NavLinkContent {...contentProps} />
      </button>
    );

  if (target)
    return (
      <a
        href={to}
        target={target}
        rel={rel}
        className={className}
        onClick={(e) => {
          if (isActive) e.preventDefault();
        }}
        aria-current={isActive ? "page" : undefined}
      >
        <NavLinkContent {...contentProps} />
      </a>
    );

  return (
    <Link
      to={to}
      className={className}
      onClick={(e) => {
        if (isActive) e.preventDefault();
      }}
      aria-current={isActive ? "page" : undefined}
    >
      <NavLinkContent {...contentProps} />
    </Link>
  );
};
